<template>
  <div class="custom-table-container">
    <!-- 表格主体 -->
    <el-table ref="tableRef" :data="data" :row-key="rowKey" :border="border" :stripe="stripe" :size="size"
      :height="height" @selection-change="handleSelectionChange" @sort-change="handleSortChange"
      @row-click="handleRowClick">
      <!-- 左侧复选框列 -->
      <!-- <el-table-column v-if="showSelection" type="selection" width="55"
        :reserve-selection="reserveSelection"></el-table-column> -->

      <!-- 动态列 -->
      <el-table-column v-for="column in columns" :key="column.prop || column.label" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :align="column.align || 'left'"
        :formatter="column.formatter" :show-overflow-tooltip="column.showOverflowTooltip || false"
        :sortable="column.sortable" :fixed="column.fixed">
        <!-- 自定义列内容插槽 -->
        <template slot-scope="scope">
          <slot v-if="$scopedSlots[column.prop]" :name="column.prop" :row="scope.row" :column="column"></slot>
          <span v-else>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <template #empty>
        <div class="empty-state">
          <el-empty :image-size="200"></el-empty>
        </div>
      </template>
    </el-table>

    <!-- 分页控件 -->
    <div class="pagination" v-if="showPagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="pageSizes" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTable',
  props: {
    // 表格数据
    data: {
      type: Array,
      default: () => []
    },
    // 列配置
    columns: {
      type: Array,
      required: true
    },
    // 分页相关
    pagination: {
      type: Object,
      default: function () {
        return {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    // 表格配置
    showSelection: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    border: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'mini'
    },
    height: {
      type: Number
    },
    reserveSelection: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 行点击
    handleRowClick(row) {
      this.$emit('row-click', row)
    },
    // 排序
    handleSortChange(selection) {
      this.$emit('sort-change', selection)
    },
    // 复选框选择变化
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
    },
    // 每页数量变化
    handleSizeChange(newSize) {
      this.$emit('size-change', newSize)
    },
    // 当前页码变化
    handleCurrentChange(newPage) {
      this.$emit('current-page-change', newPage)
    },
    // 获取选中的行
    getSelection() {
      return this.$refs.tableRef ? this.$refs.tableRef.selection : []
    },
    // 清空选中
    clearSelection() {
      this.$refs.tableRef && this.$refs.tableRef.clearSelection()
    }
  }
}
</script>

<style scoped>
.custom-table-container {
  margin-bottom: 15px;
}

.pagination {
  margin-top: 15px;
  text-align: right;
}

.el-table--mini {
  font-size: 16px;
}
</style>
